import Axios from 'axios';
import ApiUtils from './api-utils';

export default {
  getBatiments: (numTiers) => ApiUtils.responseParser(Axios.get('/web/v1/tiers/' + numTiers + '/batiments')),
  getLots: (numTiers) => ApiUtils.responseParser(Axios.get('/web/v1/tiers/' + numTiers + '/lots')),
  getExploitations: (numTiers) => ApiUtils.responseParser(Axios.get('/web/v1/tiers/' + numTiers + '/exploitations'))
};
